<template>
    <pc-loader
        v-bind:loading="isFindingProject"
        class="d-flex align-items-end"
        small>
        <pc-input
            v-model="projectNumberWrapper"
            class="w-100 me-2"
            v-bind:label="projectNumberInputLabel" />
        <div>
            <pc-button
                v-bind:disabled="!projectNumberWrapper"
                v-on:click="findProject(projectNumber)">
                {{ findProjectButtonText }}
            </pc-button>
        </div>
    </pc-loader>
    <pc-transition transition="slide">
        <template v-if="findProjectResult">
            <div v-if="projectId">
                <div class="text-success mb-2">{{ projectFoundMessage }}</div>
                <div class="overflow-auto">
                    <div
                        v-for="projectData in findProjectResult.ProjectData"
                        v-bind:key="projectData.SlotName"
                        class="d-flex">
                        <div class="text-nowrap me-2">{{ projectData.SlotName }}:</div>
                        <div class="text-nowrap">{{ projectData.SlotValue }}</div>
                    </div>
                </div>
            </div>
            <div
                v-else
                class="text-danger">
                {{ projectNotFoundMessage }}
            </div>
        </template>
    </pc-transition>
</template>

<script setup>
    import { ref, computed, inject } from "vue";
    import { DIALOG_HOOK, DIALOG_RESULT } from "Components/pc-dialog.vue";
    import { useResource } from "Util/i18n";
    import { PC_RES_SYMBOL } from "_Main/injectionSymbols";
    import { KEYS, NAMESPACE } from "./i18n/addExistingProject.i18n";

    const res = inject(PC_RES_SYMBOL);

    const props = defineProps({
        findProjectAsync: { type: Function, required: true }
    });

    const { projectNumberInputLabel, findProjectButtonText } = useResource(KEYS, NAMESPACE);

    const findProjectResult = ref(null);
    const isFindingProject = ref(false);

    const projectNumber = ref(null);
    const projectNumberWrapper = computed({
        get: () => projectNumber.value,
        set(newValue) {
            findProjectResult.value = null;
            projectNumber.value = newValue;
        }
    });

    const projectId = computed(() => findProjectResult.value?.ProjectId);

    const projectFoundMessage = computed(() => {
        return res({
            namespace: NAMESPACE,
            key: KEYS.projectFoundMessage,
            values: { projectNumber: projectNumber.value }
        });
    });

    const projectNotFoundMessage = computed(() => {
        return res({
            namespace: NAMESPACE,
            key: KEYS.projectNotFoundMessage,
            values: { projectNumber: projectNumber.value }
        });
    });

    async function findProject() {
        isFindingProject.value = true;
        findProjectResult.value = await props.findProjectAsync(projectNumber.value);
        isFindingProject.value = false;
    }

    function isValidToClose(dialogResult) {
        switch (dialogResult) {
            case DIALOG_RESULT.ok:
                return Boolean(projectId.value);
            case DIALOG_RESULT.cancel:
                return true;
            default:
                return false;
        }
    }

    defineExpose({
        [DIALOG_HOOK.isValidToClose]: isValidToClose,
        [DIALOG_HOOK.getResult]: () => projectId.value
    });
</script>
